module.exports = __webpack_public_path__ + "media/app/images/credit_card-51c41aba15ed8e4e056c9e745854fa47.png";